export const sanitizeNumericInput = (value: string): string => value.replace(/[^\d]/g, '');
